import { render, staticRenderFns } from "./AdminChannelScore.vue?vue&type=template&id=348eeef8&"
import script from "./AdminChannelScore.ts?vue&type=script&lang=ts&"
export * from "./AdminChannelScore.ts?vue&type=script&lang=ts&"
import style0 from "./AdminChannelScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports